import { render, staticRenderFns } from "./StyleDialogStyleTabs.vue?vue&type=template&id=879f3384&scoped=true&"
import script from "./StyleDialogStyleTabs.vue?vue&type=script&lang=js&"
export * from "./StyleDialogStyleTabs.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogStyleTabs.vue?vue&type=style&index=0&id=879f3384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879f3384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VListItem,VListItemTitle,VTabItem})
